import { useEffect, useState } from "react";
import { Loader2, Gamepad2 } from "lucide-react";
import { toast } from "sonner";
import { api, formatErr } from "@/lib/api";
import { Switch } from "@/components/ui/switch";
import { refreshGames } from "@/lib/games";

function GameCard({ g, onSaved }) {
  const [v, setV] = useState(g.values);
  const [busy, setBusy] = useState(false);
  const save = async () => {
    setBusy(true);
    try { const { data } = await api.put(`/admin/games/${g.id}`, v); setV(data); toast.success(`${g.name} gespeichert`); onSaved(); }
    catch (e) { toast.error(formatErr(e)); } finally { setBusy(false); }
  };
  return (
    <div className={`bg-white rounded-3xl p-5 border space-y-4 transition-opacity ${v.enabled ? "border-pink-100" : "border-slate-200 opacity-80"}`} data-testid={`game-admin-${g.id}`}>
      <div className="flex items-center justify-between gap-3">
        <p className="font-bold">{g.name}</p>
        <label className="flex items-center gap-2 text-xs font-semibold text-slate-500">{v.enabled ? "Aktiv" : "Pausiert"}
          <Switch checked={v.enabled} onCheckedChange={(on) => setV({ ...v, enabled: on })} data-testid={`game-admin-toggle-${g.id}`} />
        </label>
      </div>
      {g.fields.length > 0 && <div className="grid grid-cols-2 gap-3">
        {g.fields.map((f) => (
          <label key={f.key} className="text-xs font-semibold text-slate-500 space-y-1">
            <span className="block">{f.label}</span>
            <input type="number" min="0" value={v[f.key]} onChange={(e) => setV({ ...v, [f.key]: e.target.value })} data-testid={`game-admin-${g.id}-${f.key}`}
              className="w-full h-10 px-3 rounded-xl border border-pink-200 text-sm text-slate-800 focus:outline-none focus:ring-2 focus:ring-rose-300" />
          </label>
        ))}
      </div>}
      <button onClick={save} disabled={busy} data-testid={`game-admin-save-${g.id}`} className="h-10 px-6 rounded-full bg-rose-500 text-white font-bold text-sm disabled:opacity-50">Speichern</button>
    </div>
  );
}

export function GamesAdmin() {
  const [list, setList] = useState(null);
  useEffect(() => { api.get("/admin/games").then(({ data }) => setList(data)); }, []);
  if (!list) return <div className="flex justify-center py-10"><Loader2 className="w-6 h-6 animate-spin text-rose-500" /></div>;
  return (
    <div className="space-y-4" data-testid="games-admin">
      <p className="text-sm text-slate-500 flex items-center gap-2"><Gamepad2 className="w-4 h-4 text-rose-500" /> Pausierte Spiele verschwinden für alle Nutzer aus Menü, Feed und Spiele-Seite. Punkte und Gewinne von Glücksrad und Rubbellosen stellt ihr in ihren eigenen Reitern ein.</p>
      <div className="grid md:grid-cols-2 gap-4">{list.map((g) => <GameCard key={g.id} g={g} onSaved={() => refreshGames().catch(() => {})} />)}</div>
    </div>
  );
}
